import React from "react";

const LEAVES = [
  { x: 13, y: 36, r: -70 },
  { x: 9.5, y: 30, r: -55 },
  { x: 7, y: 23.5, r: -40 },
  { x: 6.5, y: 16.5, r: -20 },
  { x: 8, y: 10, r: 0 },
  { x: 11.5, y: 4.5, r: 25 },
];

const Branch = ({ flip, lg }) => (
  <svg
    viewBox="0 0 20 40"
    className={`${lg ? "h-16 w-8 md:h-20 md:w-10" : "h-8 w-4 md:h-9 md:w-[18px]"} text-gold ${flip ? "-scale-x-100" : ""}`}
    aria-hidden="true"
  >
    <path
      d="M16 39 C 4 32, 3 16, 14 2"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.9"
      strokeLinecap="round"
    />
    {LEAVES.map((l) => (
      <ellipse
        key={`${l.x}-${l.y}`}
        cx={l.x}
        cy={l.y}
        rx="3.6"
        ry="1.4"
        fill="currentColor"
        transform={`rotate(${l.r} ${l.x} ${l.y})`}
      />
    ))}
  </svg>
);

export const Laurel = ({ top = "Official Selection", label, className = "", lg = false }) => (
  <div
    className={`inline-flex items-center gap-0.5 bg-ink/60 backdrop-blur-sm border border-gold/25 px-2 py-1 ${className}`}
    data-testid="laurel-badge"
  >
    <Branch lg={lg} />
    <div className={`text-center leading-tight ${lg ? "px-3 max-w-[180px] md:max-w-[200px]" : "px-1.5"}`}>
      <p className={`text-gold uppercase ${lg ? "text-[9px] md:text-[10px] tracking-[0.3em]" : "text-[7px] md:text-[8px] tracking-[0.28em]"}`}>{top}</p>
      <p className={`text-bone uppercase font-sans mt-0.5 ${lg ? "text-[11px] md:text-xs tracking-[0.12em] mt-1.5" : "text-[8px] md:text-[9px] tracking-[0.1em] whitespace-nowrap"}`}>
        {label}
      </p>
    </div>
    <Branch flip lg={lg} />
  </div>
);

export default Laurel;
